<template>
  <div>
    <div class="mb-4 d-flex align-center">
      <back-btn />
      <h3 class="ml-3 title-page">{{ $t("editWarehouse") }}</h3>
    </div>
    <div
      class="d-flex justify-lg-space-between align-center warehouse_edit_top"
    >
      <div class="d-flex flex-wrap">
        <div class="info-wrap pl-0">
          <div class="info-wrap-status">
            <div class="info-wrap-status-box grey"></div>
            <div class="info-wrap-status-txt">
              {{ $t("warehouseFieldType.corridor") }}
            </div>
          </div>
        </div>
        <div class="info-wrap">
          <div class="info-wrap-status">
            <div class="info-wrap-status-box success"></div>
            <div class="info-wrap-status-txt">
              {{ $t("warehouseFieldType.stillage") }}
            </div>
          </div>
        </div>
        <div class="info-wrap">
          <div class="info-wrap-status">
            <div class="info-wrap-status-box warning"></div>
            <div class="info-wrap-status-txt">
              {{ $t("warehouseFieldType.field") }}
            </div>
          </div>
        </div>
      </div>
      <div class="">
        <v-btn color="primary" @click="save">{{ $t("save") }}</v-btn>
      </div>
    </div>
    <div class="division_main">
      <warehouse-edit-table @deleteCell="deleteCell" :data="boardData" />
    </div>
    <NotificationSystem ref="notificationError" />
  </div>
</template>

<script>
import WarehouseEditTable from "@/components/warehouse/WarehouseEditTable";
import BackBtn from "@/components/ui/BackBtn";
import { BoxService } from "@/services/BoxService.js";
import { DEFAULT_STILLAGE_BOX_SIZE } from "@/utils/constants.js";
import NotificationSystem from "@/components/notificationSystem.vue";

export default {
  props: {
    id: {
      required: true,
    },
  },
  data() {
    return {
      boardData: {
        rows: [],
        columns: [],
        boards: [],
      },
    };
  },
  components: { NotificationSystem, BackBtn, WarehouseEditTable },
  methods: {
    async save() {
      this.showLoading();
      try {
        const boardData = {
          id: this.id,
          columnCount: this.boardData.boards.length,
          rows: this.boardData.boards,
        };

        await this.$http.post("warehouse/setup", {
          value: JSON.stringify(boardData),
        });
        await this.getBoardData();
        this.setSuccess({ text: this.$t("successfullySaved") });
      } catch (e) {
        this.$refs.notificationError.open({
          title: e.response.data.error_message.title,
        });
        // this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async getBoardData() {
      this.showLoading();
      try {
        const {
          data: { data },
        } = await this.$http.get("warehouse/board", {
          params: {
            id: this.id,
          },
        });
        const boxService = new BoxService(DEFAULT_STILLAGE_BOX_SIZE);
        this.boardData = boxService.parseData(data);
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async deleteCell() {
      await this.save();
      await this.getBoardData();
    },
  },
  async created() {
    this.showLoading();
    await this.getBoardData();
    this.clearLoading();
  },
};
</script>

<style scoped>
.division_main {
  background: #fafbfc;
  border: 1px solid #e3ebf3;
  border-radius: 5px;
  margin-top: 24px;
  padding: 16px;
  min-height: 75vh;
}

@media screen and (max-width: 400px) {
  .warehouse_edit_top {
    flex-direction: column;
    align-items: flex-start !important;
    justify-content: flex-start;
    gap: 10px;
  }

  .info-wrap {
    padding-left: 0px;
  }
}
</style>
